import { Button } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { useState } from 'react';
import QueryAdder from '../QueryAdder/QueryAdder';
import QueryAdderDrawer from '../QueryAdder/QueryAdderDrawer';
import {
  getTrackerViewColor,
  TrackerDataType,
  trackerHeaderBlueByType,
  trackerHeaderBlueHoverByType,
} from '../../shared/constants/constants';
import { trackerToolbarButtonTypographySx } from '../TrackerFilter/trackerFilterToolbarStyles';

interface AddNewTableEntryButtonProps {
  dropdownTable: any;
  eventHandler: any;
  currMonth: string;
}

export default function AddNewTableEntryButton(props: AddNewTableEntryButtonProps) {
  const { dropdownTable, eventHandler, currMonth } = props;
  const [openForm, setOpenForm] = useState<boolean>(false);
  const trackerType = (Object.values(TrackerDataType) as string[]).includes(eventHandler?.type)
    ? (eventHandler.type as TrackerDataType)
    : TrackerDataType.SERVICE;

  const componentColor = getTrackerViewColor(trackerType);
  const headerBlue = trackerHeaderBlueByType[trackerType] ?? trackerHeaderBlueByType[TrackerDataType.SERVICE];
  const headerBlueHover =
    trackerHeaderBlueHoverByType[trackerType] ?? trackerHeaderBlueHoverByType[TrackerDataType.SERVICE];

  return (
    <>
      <Button
        variant="contained"
        color={componentColor}
        sx={{
          height: '32px',
          backgroundColor: headerBlue,
          color: '#FFFFFF',
          '&:hover': {
            backgroundColor: headerBlueHover,
          },
          ...trackerToolbarButtonTypographySx,
          fontWeight: 700,
        }}
        startIcon={<AddRoundedIcon sx={{ fontSize: 18 }} />}
        onClick={() => setOpenForm(true)}
        data-cy="addNewService/Interaction-button-TrackerFilter"
      >
        New
      </Button>
      <QueryAdderDrawer openForm={openForm} setOpenForm={setOpenForm}>
        <QueryAdder
          title={eventHandler.newItemModalTitle}
          dropdownTable={dropdownTable}
          currMonth={currMonth}
          setOpenForm={setOpenForm}
          eventHandler={eventHandler}
        />
      </QueryAdderDrawer>
    </>
  );
}
